import { RuStorePay } from "@/shared/lib/rustore-pay/plugin"
import { detectStore } from "./detect-store"

// Custom scheme, no `https://` equivalent exists for this screen. Capacitor
// turns any non-app-host navigation into `Intent.ACTION_VIEW` and swallows
// `ActivityNotFoundException`, so a missing RuStore app fails silently — hence
// the `isRuStoreInstalled()` gate instead of a try/catch around the navigation.
const SUBSCRIPTIONS_URL = "rustore://profile/subscriptions"

/**
 * Opens the user's subscription list in the RuStore app, where auto-renewal is
 * turned off. Returns false when the hand-off is impossible (wrong store, or
 * RuStore is not installed) so the caller can keep showing its own message.
 */
export async function openRuStoreSubscriptions(): Promise<boolean> {
	if (detectStore() !== "rustore") return false

	try {
		const { installed } = await RuStorePay.isRuStoreInstalled()
		if (!installed) return false
	} catch {
		return false
	}

	window.location.href = SUBSCRIPTIONS_URL
	return true
}
